import { FC, useState } from "react";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { Add, Description, GppGood } from "@mui/icons-material";
import CreateGameWizard from "@components/dialogs/CreateGameWizard";
import { PdfData } from "@/models/pdfData";
import { Views } from "@/models/gameGeneral";
import ValidateGamesDialog from "@components/dialogs/ValidateGamesDialog";

const style = {
  margin: 0,
  top: "auto",
  right: 20,
  bottom: 20,
  left: "auto",
  position: "fixed",
};

const FabSpeeddial: FC<{
  onCreateGame: (game: PdfData, destination: Views) => void;
  onCreateEmpty: () => void;
}> = ({ onCreateGame, onCreateEmpty }) => {
  const [openWizard, setOpenWizard] = useState(false);
  const [openValidation, setOpenValidation] = useState(false);

  const handleCloseWizard = () => setOpenWizard(false);
  const handleOpenValidation = () => setOpenValidation(true);

  const handleOpenWizard = () => setOpenWizard(true);

  const handleCloseValidation = () => setOpenValidation(false);

  return (
    <>
      <SpeedDial
        color="secondary"
        sx={style}
        ariaLabel={"SpeedDial"}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          key={"newGame"}
          icon={<Add />}
          tooltipTitle={"Neues Spiel"}
          onClick={handleOpenWizard}
        />
        <SpeedDialAction
          key={"emptyProtocol"}
          icon={<Description />}
          tooltipTitle={"Leeres Protokoll"}
          onClick={onCreateEmpty}
        />
        {process.env.NODE_ENV === "development" && (
          <SpeedDialAction
            key={"testGames"}
            icon={<GppGood />}
            tooltipTitle={"Spiele validieren"}
            onClick={handleOpenValidation}
          />
        )}
      </SpeedDial>
      <CreateGameWizard
        open={openWizard}
        handleClose={handleCloseWizard}
        onCreateGame={(game, destination) => {
          handleCloseWizard();
          onCreateGame(game, destination);
        }}
      />
      {process.env.NODE_ENV === "development" && (
        <ValidateGamesDialog
          open={openValidation}
          handleClose={handleCloseValidation}
        ></ValidateGamesDialog>
      )}
    </>
  );
};

export default FabSpeeddial;
